module.exports = "/_next/static/images/civil-de87dfc71a3e421471c0a686b411399f.webp";